import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge } from "react-bootstrap";
import { Tooltip, OverlayTrigger, Popover } from "react-bootstrap";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import "react-datepicker/dist/react-datepicker.css";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import machinery from '../../../../images/vehicle/default_machinery.png';
import vehicle from '../../../../images/vehicle/default_vehicle.png';
import MaintenanceUpdate from '../../../modal/Vehicle_Management/Manage_Maintenance/Update';
import AddMaintenance from '../../../modal/Vehicle_Management/Manage_Maintenance/AddMaintenance';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const Maintenance = () => {

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const defaultPermissions = {
        view_dashboard: 0,
        branch_man: 0,

        // ----------------------- branch --------------------
        man_branch: 0,
        branch_list: 0,
        branch_add: 0,
        branch_edit: 0,
        branch_view: 0,
        branch_delete: 0,
        branch_add_staff: 0,
        branch_add_area: 0,
        branch_add_dpoint: 0,
        branch_asign_manager: 0,
        branch_asign_cug: 0,

        man_dpoint: 0,
        dpoint_list: 0,
        dpoint_edit: 0,
        dpoint_delete: 0,
        dpoint_assign_vehicle: 0,

        // --------------------------- pack -------------------
        pack_man: 0,
        man_product: 0,
        prod_catego: 0,
        product_category_list: 0,
        product_category_add: 0,
        product_category_edit: 0,
        product_category_delete: 0,

        product: 0,
        products_list: 0,
        products_add: 0,
        products_edit: 0,
        products_view: 0,
        products_delete: 0,
        products_item_quantity: 0,

        item_quans: 0,
        item_quantity_list: 0,
        item_quantity_edit: 0,
        item_quantity_view: 0,

        man_pack: 0,
        package_list: 0,
        package_edit: 0,
        package_delete: 0,

        // ---------------------- lead ---------------
        lead_man: 0,
        man_lead: 0,
        lead_list: 0,
        lead_add: 0,
        lead_edit: 0,
        lead_followup: 0,
        lead_view: 0,
        lead_import: 0,
        lead_export: 0,
        lead_subscribe: 0,
        lead_approve_spam: 0,
        lead_approve_dead: 0,

        man_coupon: 0,
        coupon_list: 0,
        coupon_add: 0,
        coupon_edit: 0,
        coupon_view: 0,
        points_add: 0,
        points_edit: 0,

        man_followup: 0,
        followup_list: 0,

        man_calls: 0,
        calls_list: 0,
        calls_location: 0,
        calls_add_lead: 0,

        lead_calender: 0,
        calender_list: 0,

        lead_source: 0,
        source_list: 0,

        // -------------------------------- team ---------------------
        team_man: 0,
        team_lead: 0,
        team_lead_list: 0,
        team_followup: 0,
        team_followup_list: 0,
        team_calls: 0,
        team_calls_list: 0,
        team_promise: 0,
        promise_month_list: 0,
        promise_today_list: 0,

        subscri_man: 0,
        subscriber_list: 0,
        subscriber_view: 0,
        subscriber_edit: 0,
        subscriber_filter: 0,
        subscriber_new_subscription: 0,
        subscriber_drop_subscription: 0,

        // ------------------------------- subscription ------------------
        subs_man: 0,
        man_subs: 0,
        subscription_list: 0,
        subscription_view: 0,
        subscription_edit: 0,
        subscription_export: 0,
        subscription_hold: 0,
        subscription_complaints: 0,
        subscription_renewal: 0,
        subscription_payment: 0,
        subscription_drop: 0,
        subscription_special_case: 0,

        man_order: 0,
        order_list: 0,
        order_edit: 0,
        order_view: 0,
        order_new_subs: 0,
        order_drop_subs: 0,
        order_convert_subscriber: 0,

        man_drop: 0,
        drop_list: 0,
        drop_export: 0,

        // ----------------------------------- payment ------------------------
        pay_man: 0,
        man_payment: 0,
        payment_export: 0,
        payment_list: 0,

        man_refund: 0,
        refund_list: 0,
        refund_export: 0,
        refund_update: 0,

        // -------------------------- production ----------------------
        prod_man: 0,
        man_items: 0,
        item_catego: 0,
        item_category_list: 0,
        item_category_add: 0,
        item_category_edit: 0,
        item_category_delete: 0,

        item_sub_catego: 0,
        item_sub_category_list: 0,
        item_sub_category_add: 0,
        item_sub_category_edit: 0,
        item_sub_category_delete: 0,

        items: 0,
        items_list: 0,
        items_add: 0,
        items_edit: 0,
        items_view: 0,
        items_delete: 0,
        item_needed_material: 0,
        item_receipe_notes: 0,

        comp_man: 0,
        complaint_list: 0,
        complaint_add: 0,
        complaint_status: 0,
        complaint_view: 0,

        maintenance_man: 0,
        man_vehi: 0,
        vehicle_list: 0,
        vehicle_add: 0,
        vehicle_edit: 0,
        vehicle_view: 0,
        vehicle_delete: 0,
        vehicle_maintannce: 0,
        vehicle_export: 0,

        man_mainten: 0,
        maintenance_list: 0,
        maintenance_edit: 0,
        maintenance_status: 0
    };

    // Immediately load from localStorage if available
    const initialPermissions = (() => {
        const stored = localStorage.getItem('user_permissions');
        return stored ? JSON.parse(stored) : defaultPermissions;
    })();

    const [permissions, setPermissions] = useState(initialPermissions);

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const imgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;
    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    // pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);

    const fetchData = () => {
        axios.get(`${baseURL}/manage_maintenance`, {
            params: {
                page,
                per_page: perPage,
                search: searchTerm,
                branch_id: branch_id
            }
        }).then(response => {
            setData(response.data.data);
            setHasFetched(true);
            setTotalPages(response.data.last_page);
        }).catch(error => {
            console.log('There was an error fetching the data!', error);
            setHasFetched(true);
        });
    };

    // fetch dat
    useEffect(() => {
        fetchData();
    }, [page, searchTerm, perPage]);

    const tableRef = useRef(null);
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };

    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);

    // add page
    const handleModalToggle = () => {
        setModalType("Add");
        setOpen(true);
    };

    const [selectedRow, setSelectedRow] = useState({});

    const handleUpdateSchedule = (selectedRow) => {
        setSelectedRow(selectedRow);
        setModalType("UpdateSchedule");
        setOpen(true);
    };

    useEffect(() => {
        if (hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "responsive": true,
                        //   "aaSorting": [],
                        "ordering": false,
                        "pageLength": 25,
                        "language": {
                            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched]);

    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const handleStatusToggle = async (id, currentStatus) => {
        const newStatus = currentStatus === 0 ? 1 : 0;
        axios.put(`${baseURL}/manage_maintenance/status/${id}`, { status: newStatus })
            .then(response => {
                // softRefresh();
                toast.success("Status Updated Successfully!");
            })
            .catch(error => {
                console.log(error);
                toast.error("Status Updation Failed");
            });
    };

    const softRefresh = () => {
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchData();
    }

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Manage Maintenance</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Maintenance Management</li>
                    </ol>
                </div>

                <div className='d-flex align-items-center gap-3 mb-2'>
                    <button className="btn btn-primary float-end btn-sm" onClick={handleModalToggle}>
                        <span className='me-2'><i className="fa-solid fa-plus fs-8"></i></span>
                        <span className=''>Add Maintenance</span>
                    </button>
                </div>

                {open && modalType === "UpdateSchedule" && (
                    <MaintenanceUpdate show={open} onClose={() => setOpen(false)} data={selectedRow} refresh={softRefresh} />
                )}

                {open && modalType === "Add" && (
                    <AddMaintenance show={open} onClose={() => setOpen(false)} refresh={softRefresh} />
                )}
            </div>

            {permissions.maintenance_list === 1 && (
                <div className="table-container">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        {/* Left: Show entries dropdown */}
                        <div>
                            <label className="me-2">Show</label>
                            <select
                                className="form-select d-inline w-auto"
                                style={{ fontSize: '0.85rem', height: '30px' }}
                                value={perPage}
                                onChange={(e) => {
                                    setPerPage(Number(e.target.value));
                                    setPage(1); // Reset to first page
                                }}
                            >
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                        </div>

                        {/* Right: Search input */}
                        <div>
                            <input
                                type="text"
                                style={{ fontSize: '0.85rem', height: '40px' }}
                                placeholder="Search..."
                                className="form-control"
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setPage(1); // Reset page on new search
                                }}
                            />
                        </div>
                    </div>

                    <table style={{ borderBottom: '2px solid #ddd' }} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                        <thead>
                            <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                <th className='min-w-100px'>Vehicle</th>
                                <th className='min-w-100px'>Number / Reg Date</th>
                                <th className='min-w-100px'>Scheduled Date</th>
                                <th className='min-w-80px'>Service Type</th>
                                <th className='min-w-50px text-center'>Service Amount</th>
                                <th className='min-w-80px text-center'>Actions</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold fs-7">
                            {datas.length === 0 && hasFetched ? (
                                <tr>
                                    <td colSpan="7" className="text-center text-muted py-2">
                                        No data available
                                    </td>
                                </tr>
                            ) : (
                                <>
                                    {datas.map((data, index) => (
                                        <tr key={data.sno}>
                                            <td>
                                                {data.maintenance_type === 0 ? (
                                                    <div className="d-flex align-items-center justify-content-start gap-2">
                                                        <LightGallery
                                                            onInit={onInit}
                                                            speed={500}
                                                            plugins={[lgThumbnail, lgZoom]}
                                                        >
                                                            <div data-src={(imgBaseUrl && data.image) ? imgBaseUrl + '/' + data.image : vehicle} className='border rounded px-1 py-0'>
                                                                <img src={(imgBaseUrl && data.image) ? imgBaseUrl + '/' + data.image : vehicle} alt={data.brand_name + ' ' + data.category_name} className='cursor-pointer w-45px h-45px' />
                                                            </div>
                                                        </LightGallery>
                                                        <div>
                                                            <OverlayTrigger
                                                                trigger={['hover', 'focus']}
                                                                placement="bottom"
                                                                overlay={
                                                                    <Tooltip className="toltip-popover">
                                                                        <span className="fs-8 text-white">Vehicle Category</span>
                                                                    </Tooltip>
                                                                }
                                                            ><label className='text-black font-w400 fs-7'>{data.category_name}</label></OverlayTrigger>
                                                            <div className="d-block">
                                                                <OverlayTrigger
                                                                    trigger={['hover', 'focus']}
                                                                    placement="bottom"
                                                                    overlay={
                                                                        <Tooltip className="toltip-popover">
                                                                            <span className="fs-8 text-white">Brand</span>
                                                                        </Tooltip>
                                                                    }
                                                                ><label className="fs-8 text-dark font-w600">{data.brand_name}</label></OverlayTrigger>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="d-flex align-items-center justify-content-start gap-2">
                                                        <LightGallery
                                                            onInit={onInit}
                                                            speed={500}
                                                            plugins={[lgThumbnail, lgZoom]}
                                                        >
                                                            <div data-src={(imgBaseUrl && data.image) ? imgBaseUrl + '/' + data.image : machinery} className='border rounded px-1 py-0'>
                                                                <img src={(imgBaseUrl && data.image) ? imgBaseUrl + '/' + data.image : machinery} alt={data.machinery_anme} className='cursor-pointer w-45px h-45px' />
                                                            </div>
                                                        </LightGallery>
                                                        <div>
                                                            <OverlayTrigger
                                                                trigger={['hover', 'focus']}
                                                                placement="bottom"
                                                                overlay={
                                                                    <Tooltip className="toltip-popover">
                                                                        <span className="fs-8 text-white">Machinery Name</span>
                                                                    </Tooltip>
                                                                }
                                                            ><label className='text-black font-w400 fs-7'>{data.machinery_anme}</label></OverlayTrigger>
                                                            <div className="d-block">
                                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white">Brand</span></Tooltip>}>
                                                                    <label className="fs-8 text-dark font-w600">{data.brand_name}</label>
                                                                </OverlayTrigger>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </td>
                                            <td>
                                                {data.manage_maintenance === 0 ? (
                                                    <>
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white">Vehicle Number</span></Tooltip>}>
                                                            <label className='text-black font-w400 fs-7'>{data.number}</label>
                                                        </OverlayTrigger>
                                                        <div className="d-block">
                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white">Vehicle Reg Date</span></Tooltip>}>
                                                                <label className="fs-8 text-dark font-w600">{formatDate(data.reg_date)}</label>
                                                            </OverlayTrigger>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white">Serial Number</span></Tooltip>}>
                                                            <label className='text-black font-w400 fs-7'>{data.number}</label>
                                                        </OverlayTrigger>
                                                        <div className="d-block">
                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white">Purchase Date</span></Tooltip>}>
                                                                <label className="fs-8 text-dark font-w600">{formatDate(data.reg_date)}</label>
                                                            </OverlayTrigger>
                                                        </div>
                                                    </>
                                                )}
                                            </td>
                                            <td>
                                                <Badge bg="warning" className='py-0 px-1 fs-7'>{formatDate(data.upcomming_maintanence_date)}</Badge>
                                                <div className="d-block">
                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white">Service Notes</span></Tooltip>}>
                                                        <label className="fs-8 text-dark font-w600">{data.service_notes}</label>
                                                    </OverlayTrigger>
                                                </div>
                                            </td>
                                            <td>
                                                {data.service_names ? (() => {
                                                    const products = data.service_names.split(',').map(p => p.trim());
                                                    const visibleCount = 1;
                                                    const visibleProducts = products.slice(0, visibleCount);
                                                    const hiddenCount = products.length - visibleCount;

                                                    const popover = (
                                                        <Popover id="popover-products" className="toltip-popover" style={{ maxWidth: '200px' }}>
                                                            <Popover.Body>
                                                                {products.map((product, idx) => (
                                                                    <div key={idx} className="fs-8 text-black fw-semibold">
                                                                        {product}
                                                                    </div>
                                                                ))}
                                                            </Popover.Body>
                                                        </Popover>
                                                    );

                                                    return (
                                                        <>
                                                            <span className="text-black font-w400 fs-7">
                                                                {visibleProducts.join(', ')}
                                                                {hiddenCount > 0 && ', '}
                                                            </span>

                                                            {hiddenCount > 0 && (
                                                                <OverlayTrigger
                                                                    trigger={['hover', 'click']}
                                                                    placement="bottom"
                                                                    overlay={popover}
                                                                    rootClose
                                                                >
                                                                    <span
                                                                        style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                                                        className="fs-7 text-primary"
                                                                    >
                                                                        + {hiddenCount} more
                                                                    </span>
                                                                </OverlayTrigger>
                                                            )}
                                                        </>
                                                    );
                                                })() : (
                                                    <div className='text-truncate mw-300px text-black font-w400 fs-7'>-</div>
                                                )}
                                            </td>
                                            <td className='text-end align-content-center'>
                                                <label className='text-danger font-w500 fs-5 text-end'> ₹ {data.service_amount}</label>
                                            </td>
                                            <td className='text-center'>
                                                <span className="text-end">
                                                    {permissions.maintenance_edit === 1 && (
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                                            <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleUpdateSchedule(data)}>
                                                                <span><i className="fa-solid fa-pen-to-square fs-6 mt-1"></i></span>
                                                            </Button>
                                                        </OverlayTrigger>
                                                    )}
                                                </span>

                                                {permissions.maintenance_edit != 1 && (
                                                    <div className="text-center">
                                                        No Actions
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </>
                            )}
                        </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        {/* Bottom left: Showing x to y of z entries */}
                        <div>
                            {datas.length > 0 ? (
                                <span className="text-muted">
                                    Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {totalPages * perPage - (perPage - datas.length)} entries
                                </span>
                            ) : (
                                <span className="text-muted">
                                    Showing 0 to 0 of 0 entries
                                </span>
                            )}
                        </div>

                        {/* Bottom right: Pagination */}
                        <nav>
                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                </li>
                                {[...Array(totalPages)].map((_, i) => (
                                    <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                    </li>
                                ))}
                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                </li>
                            </ul>
                        </nav>

                    </div>
                </div>
            )}

            {permissions.maintenance_list === 0 && (
                <div className='align-content-center' style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '10%',
                    // height: '100vh',       // full viewport height
                    color: 'red',          // text-danger equivalent
                    fontSize: '24px',      // increase font size
                    fontWeight: 'bold'     // optional for emphasis
                }}>
                    <label>No Access</label>
                </div>
            )}

        </>
    )
}
export default Maintenance;